
import React from 'react';
import { Project } from '../../services/apiService';


const ProjectIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
  </svg>
);

interface ProjectHeaderProps {
  project: Project;
  stats: { 
    calls: number;
    tokens: number;
  };
}

export default function ProjectHeader({ project, stats }: ProjectHeaderProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  
  return (
    <div className="project-header">
      <div className="project-header-main">
        <div className="project-header-icon">
          <ProjectIcon />
        </div>
        <div className="project-header-info">
          <h1 className="project-name">{project.name}</h1>
          <div className="project-meta">
            <span className="project-created">Created {formatDate(project.created_at)}</span>
            <span className="project-id">ID: {project.id.substring(0, 8)}</span>
          </div>
        </div>
      </div>
      <div className="project-stats">
        <div className="project-stat">
          <span className="project-stat-label">API Calls</span>
          <span className="project-stat-value">{stats.calls.toLocaleString()}</span>
        </div>
        <div className="project-stat">
          <span className="project-stat-label">Tokens Used</span>
          <span className="project-stat-value">{stats.tokens.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
}